import React from 'react';

import { Box } from '@mui/material';

import useSectionNavigationPreference, { SECTION_NAVIGATION_MODES } from '~/hooks/useSectionNavigationPreference';

import { SECTION_NAVIGATION_SIDEBAR_MEDIA } from './sectionNavigationBreakpoint';

interface Props {
  navigation: React.ReactNode;
  children: React.ReactNode;
}

export default function SectionNavigationLayout({ navigation, children }: Props) {
  const [sectionNavigationMode] = useSectionNavigationPreference();
  const prefersHeaderSections = sectionNavigationMode === SECTION_NAVIGATION_MODES.HEADER;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr)',
        ...(prefersHeaderSections
          ? {}
          : { [SECTION_NAVIGATION_SIDEBAR_MEDIA]: { gridTemplateColumns: '240px minmax(0, 1fr)' } }),
        gap: 3,
        alignItems: 'start',
      }}
    >
      {navigation}
      <Box sx={{ minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
